import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { THsCodesApi } from './types';

export const hscodes: THsCodesApi = {
	getHsCodes: (payload) =>
		http.get(endpoint.hscodes.HS_CODES, { params: payload }).then((response) => response.data),
	getHsCodesById: (id) =>
		http.get(endpoint.hscodes.HS_CODES_BY_ID(id)).then((response) => response.data),
};
